import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

type PrivateRouteProps = {
  children?: React.ReactNode;
};

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    // Redirect to the login page, but save the current location they were trying to go to
    return <Navigate to="/login" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}
